import { render, staticRenderFns } from "./EndorsementTable.vue?vue&type=template&id=2b0f620c"
import script from "./EndorsementTable.vue?vue&type=script&lang=ts"
export * from "./EndorsementTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports